import { useForm, SubmitHandler } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { SignInRequest } from "./api/requestTypes";

export type Inputs = SignInRequest;

const schema = z.object({
  email: z
    .string()
    .min(1, { message: "Enter a valid email address" })
    .email({ message: "Enter a valid email address" })
});

const defaultValues = {
  email: ""
};

const useForgotPassword = () => {
  const { handleSubmit, control, errors } = useForm<Inputs>({
    defaultValues,
    resolver: zodResolver(schema)
  });

  const onSubmit: SubmitHandler<Inputs> = data => console.log(data);
  console.log({ errors });
  return {
    handleSubmit: handleSubmit(onSubmit),
    control
  };
};

export default useForgotPassword;
